export default "/images/candy-image-75.png?0f5b9990ee10a846e504ab2470d27956";